<p-dialog
	*ngIf="printerDeviceSelected"
	[(visible)]="printerDeviceSelected"
	[closable]="true"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
>
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'print']" class="me-4" size="lg"></fa-icon>
		Manage Printer
	</ng-template>

	<div class="d-flex flex-column">
		<div class="w-100">
			<span class="p-float-label mt-4">
				<input
					pInputText
					#printerDeviceName
					name="printerDeviceName"
					type="text"
					[(ngModel)]="printerDeviceSelected.name"
					class="w-100"
					(input)="changesToSave = true"
				/>
				<label for="printerDeviceName">Printer Name</label>
			</span>
		</div>
		<div class="w-100 d-flex">
			<div class="flex-fill mx-2 mt-4">
				<span class="p-float-label">
					<p-dropdown
						#printerIdValue
						[options]="availablePrinterId"
						optionLabel="label"
						optionValue="value"
						optionDisabled="disabled"
						name="printerIdValue"
						[(ngModel)]="printerDeviceSelected.posId"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(availablePrinterId)"
						(onChange)="changesToSave = true"
					></p-dropdown>
					<label for="printerIdValue">Printer ID</label>
				</span>
			</div>
			<div class="flex-fill mx-2 mt-4">
				<span class="p-float-label">
					<p-dropdown
						#printerDeviceControllingPosDeviceList
						[options]="posStationList"
						optionLabel="Name"
						optionValue="ID"
						name="printerDeviceControllingPosDeviceList"
						[(ngModel)]="printerDeviceSelected.controllingPosDeviceId"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(posStationList)"
						(onChange)="setControllingDevice(); changesToSave = true"
					></p-dropdown>
					<label for="printerDeviceControllingPosDeviceList">Controlling POS Device</label>
				</span>
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			(onCancelChange)="printerDeviceSelected = undefined; printerDeviceSelectedChange.emit(undefined)"
			(onDeleteChange)="onDelete()"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[deleteDisabled]="!printerDeviceSelected.sk"
			[saveDisabled]="!printerDeviceSelected.controllingPosDeviceId || !printerDeviceSelected.posId || !changesToSave"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
